/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function ($) {
  // Remove empty P tags created by WP inside of Accordion and Orbit
  $(".accordion p:empty, .orbit p:empty").remove();

  $(".kb-blocks-slider").attr("aria-label", "carousel");

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
      $(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      $(this).wrap("<div class='responsive-embed'/>");
    }
  });

  if ($(window).width() > 1024) {
    $(".blog-single .entry-content img").attr("data-open", "blog-img-modal");
    $(".blog-single .entry-content img").click(function () {
      $("#blog-img-modal").empty();
      $(this).clone().appendTo("#blog-img-modal");
    });
  }

  // Testimonial desktop modal view
  var testimonial = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

  if ($(window).width() > 765) {
    $.each(testimonial, function (i, val) {
      $(".testimonialbtn-" + val).click(function () {
        $("#testimonial-modal").empty();
        $(".testimonial-card-" + val)
          .clone()
          .appendTo("#testimonial-modal");
      });
    });
  }

  // Testimonial mobile show more dropdown
  if ($(window).width() < 766) {
    $(".reveal-overlay").remove();

    $.each(testimonial, function (i, val) {
      $(".testimonialbtn-" + val).click(function (e) {
        e.preventDefault();
        var $quote = $(".testimonial-quote-" + val);
        var $readMore = $(".readMore-" + val);

        if ($readMore.is(":visible")) {
          // Collapse back to ellipsis
          $readMore.hide(); // Hide the extra content
          $quote.css({
            display: "-webkit-box",
            "-webkit-line-clamp": "8",
            overflow: "hidden",
            "text-overflow": "ellipsis",
          });
        } else {
          // Expand to show full content
          $quote.css({
            display: "block",
            "-webkit-line-clamp": "unset",
            overflow: "visible",
            "text-overflow": "unset",
          });
          $readMore.show(); // Show the extra content
        }
      });
    });
  }

  // Journey Apprentice mobile tabs
  if ($(window).width() < 765) {
    let journeyHeader = $(".joAppHeader-1");
    let apprenticeHeader = $(".joAppHeader-2");
    let journeyManContent = document.querySelectorAll(".joAppHide-1");
    let apprenticeContent = document.querySelectorAll(".joAppHide-2");

    // Click event for journeyman header
    journeyHeader.click(function (e) {
      e.preventDefault();

      // Clear previous content
      $(".journeyman-show").empty();

      // Append the correct content
      journeyManContent.forEach(function (element) {
        let clonedElement = $(element).clone();
        clonedElement.css("display", "block"); // Remove class here
        clonedElement.appendTo($(".journeyman-show"));
      });

      // Show the container
      journeyHeader.toggleClass("spin-arrow");
      $(".journeyman-show").slideToggle("slow");
    });

    // Click event for apprentice header
    apprenticeHeader.click(function (e) {
      e.preventDefault();

      // Clear previous content
      $(".apprentice-show").empty();

      // Append the correct content
      apprenticeContent.forEach(function (element) {
        let clonedElement = $(element).clone();
        clonedElement.css("display", "block"); // Remove class here
        clonedElement.appendTo($(".apprentice-show"));
      });

      // Show the container
      apprenticeHeader.toggleClass("spin-arrow");
      $(".apprentice-show").slideToggle("slow");
    });
  }

  //ADA Fix
  jQuery(".kb-blocks-bg-video").attr(
    "aria-label",
    "Archer mechanical youtube video"
  );
  jQuery(".kb-gallery-carousel").attr("aria-label", "Carousel");

  jQuery(".blogs-excerpt").append("[...]");

  // Element: "Read More" Toggle Buttons
  var instance = ["1", "2", "3", "4", "5"];
  $.each(instance, function (i, val) {
    $(".toggle-" + val).click(function (e) {
      e.preventDefault();
      $(".showHide-" + val).slideToggle();
      $(this).text($(this).text() == "Read More" ? "Read Less" : "Read More");
    });
  });

  // Element: "Read More" Toggle Buttons
  var mobileInstance = ["1", "2", "3", "4", "5"];
  $.each(mobileInstance, function (i, val) {
    $(".mobile-toggle-" + val).click(function (e) {
      e.preventDefault();
      $(".showHideMobile-" + val).slideToggle();
      $(this).toggleClass("mobile-spin-arrow");
    });
  });

  $(".child-link-underline a").addClass("link-underline");

  $("iframe").removeAttr("frameborder");

  // if class has gridTriggers add aria-label that is the same as title
  $(".gridTriggers").each(function () {
    var title = $(this).attr("title");
    $(this).attr("aria-label", title);
  });

  //Sitemap
  $("a[href*='/sitemap']").each(function () {
    $(this).attr("aria-label", "sitemap");
    $(this).addClass("link-underline");
  });

  // home page portfolio - project descriptions
  $(".home-portfolio .kt-blocks-post-grid-item-inner .entry-content").each(
    function () {
      let title = $(this)
        .closest(".kt-blocks-post-grid-item-inner")
        .find("h3 a")
        .text();
      let content = $(this).text();
      // Remove the title from the content
      let contentNoTitle = content.replace(title, "");
      // Add <br> before capital letters (e.g., "OfficePlan" becomes "Office<br>Plan")
      contentNoTitle = contentNoTitle.replace(/([a-z])([A-Z])/g, "$1<br>$2");
      // Add <br> before numbers (e.g., "Spec250,000" becomes "Spec<br>250,000")
      contentNoTitle = contentNoTitle.replace(/([a-zA-Z])(\d)/g, "$1<br>$2");
      // Convert to lowercase for case-insensitive searching
      let lowerContent = contentNoTitle.toLowerCase();
      // Find the index of 'utah' and 'sqft'
      let state = lowerContent.indexOf("utah");
      let index = lowerContent.indexOf("sqft");
      if (state !== -1 && index !== -1) {
        // Extract the content between 'utah' and 'sqft'
        let result = contentNoTitle
          .slice(state + "utah".length, index + "sqft".length)
          .trim();
        // Update the content with the sliced result
        $(this).html(result); // Use .html() to preserve the <br> tags
      }
    }
  );

  //Company SVG
  let slices = $("#outer-wheel .slice-indicator").toArray();
  let tabs = $("#company-tabs .kt-blocks-accordion-header").toArray();
  let pcQuarter = $("#cycle-ring .quarter-fill-preconstruction");
  let coorQuarter = $("#cycle-ring .quarter-fill-coordination");
  let constructQuarter = $("#cycle-ring .quarter-fill-construction");
  let bsQuarter = $("#cycle-ring .quarter-fill-building-services");

  let cycle = [pcQuarter, coorQuarter, constructQuarter, bsQuarter];

  $.each(tabs, function (index) {
    $(tabs[index]).click(function () {
      // First, remove 'slice-bg-active' from all slices
      $.each(slices, function (i) {
        $(slices[i]).removeClass("slice-bg-active");
      });

      // Determine which cycles to activate based on the tab index
      let activeCycles = [];
      if (index === 1 || index === 2) {
        activeCycles = [0];
      } else if (index === 3) {
        activeCycles = [0, 1];
      } else if (index === 4) {
        activeCycles = [1];
      } else if (index === 5) {
        activeCycles = [1, 2];
      } else if (index === 6) {
        activeCycles = [2];
      } else if (index === 7) {
        activeCycles = [2, 3];
      } else if (index === 0 || index === 8) {
        activeCycles = [3];
      }

      $.each(cycle, function (x) {
        // Remove the green from all inner cycles except the current ones
        if (!activeCycles.includes(x)) {
          $(cycle[x]).removeClass("cycle-fill-active");
        }
      });

      // Add green to the active cycles
      $.each(activeCycles, function (_, cycleIndex) {
        $(cycle[cycleIndex]).addClass("cycle-fill-active");
      });

      // Add 'slice-bg-active' to the correct slice based on index
      if (index === 0) {
        $(slices[slices.length - 1]).addClass("slice-bg-active");
      } else {
        $(slices[index - 1]).addClass("slice-bg-active");
      }
    });
  });

// First, add the arrow HTML elements
$(".home-portfolio").before(`
  <button class="portfolio-prev show-for-large" aria-label="Previous projects"></button>
`);

$(".home-portfolio").after(`
  <button class="portfolio-next show-for-large" aria-label="Next projects"></button>
`);

$(".home-portfolio .kt-post-grid-layout-grid-wrap.kt-post-grid-wrap").append(`
  <article class="kt-blocks-post-grid-item avada_portfolio type-avada_portfolio status-publish has-post-thumbnail hentry portfolio_category-current-projects portfolio_category-entertainment view-all-post">
    <a href="/completed-projects/" class="kadence-post-image-inner-wrap">
      <h4>VIEW ALL PROJECTS //</h4>
      <img src="/wp-content/uploads/2024/08/Subtract.png" />
    </a>
  </article>
`);

// Add the click handlers

const container = $(".home-portfolio .kt-post-grid-layout-grid-wrap.kt-post-grid-wrap");
let currentPosition = 0;
const slideAmount = 28; // 28% movement

// Function to update the button visibility based on scroll position
function updateButtonVisibility() {
  const maxScroll = container[0].scrollWidth - container.width();
  const currentScroll = container.scrollLeft();

  // Calculate the current position as a percentage
  currentPosition = (currentScroll / maxScroll) * 100;

  // Show/hide buttons based on position
  if (currentScroll <= 0) {
    $(".portfolio-prev").fadeOut();
  } else {
    $(".portfolio-prev").fadeIn();
  }

  if (currentScroll >= maxScroll) {
    $(".portfolio-next").fadeOut();
  } else {
    $(".portfolio-next").fadeIn();
  }
}

// Initial button visibility
updateButtonVisibility();

// Arrow click handlers
$(".portfolio-next").click(function () {
  const maxScroll = container[0].scrollWidth - container.width();
  currentPosition = Math.min(currentPosition + slideAmount, 100);

  container.animate(
    {
      scrollLeft: (maxScroll * currentPosition) / 100,
    },
    500,
    updateButtonVisibility
  );
});

$(".portfolio-prev").click(function () {
  const maxScroll = container[0].scrollWidth - container.width();
  currentPosition = Math.max(currentPosition - slideAmount, 0);

  container.animate(
    {
      scrollLeft: (maxScroll * currentPosition) / 100,
    },
    500,
    updateButtonVisibility
  );
});

// Sync currentPosition with manual scrolling
container.on("scroll", updateButtonVisibility);

// Initially hide the prev button
$(".portfolio-prev").hide();


  const baseUrl =
    "https://www.youtube.com/embed/idTKvni0K3Y?autoplay=1&controls=0&mute=1&muted=1&loop=1&playlist=idTKvni0K3Y&disablekb=1&modestbranding=1&playsinline=1&rel=0";
  // Array of start times in seconds (0:00, 0:20, 0:40, 0:55)
  const startTimes = [0, 20, 40, 55];
  // Choose a random start time from the array
  const randomStartTime =
    startTimes[Math.floor(Math.random() * startTimes.length)];
  // Construct the URL with the chosen start time
  const videoUrl = `${baseUrl}&start=${randomStartTime}`;

  // Update the iframe's src attribute with the new URL
  $(".parallax-video .kb-blocks-bg-video").attr("src", videoUrl);
});

function copyLink() {
  let toggleCopy = document.querySelectorAll(".toggleCopy");
  window.navigator.clipboard.writeText(window.location.href);
  toggleCopy.forEach((ele) => {
    ele.classList.remove("hide");
  });

  setTimeout(function () {
    toggleCopy.forEach((ele) => {
      ele.classList.add("hide");
    });
  }, 1000);
}

// Services slider-carousel
const serviceTabs = Array.prototype.slice.call(
  document.querySelectorAll(".services-slides-tabs ul li")
);
const serviceSlides = Array.prototype.slice.call(
  document.querySelectorAll(
    ".services-slides .kb-row-layout-wrap.kt-row-has-bg"
  )
);
if (serviceTabs.length > 0 && serviceSlides.length > 0) {
  let currentSlideIndex = 0;

  function showSlide(index) {
    if (index !== currentSlideIndex) {
      // New slide enters from the top
      serviceSlides[index].style.transform = "translateY(-100%)";
      serviceSlides[index].style.display = "block";

      // Force reflow to ensure the transition is applied
      serviceSlides[index].offsetHeight;

      // Animate both slides simultaneously
      serviceSlides[currentSlideIndex].style.transform = "translateY(100%)"; // Active slide exits through the bottom
      serviceSlides[index].style.transform = "translateY(0%)"; // New slide enters from the top
      serviceSlides[index].style.transition = "transform 0.5s ease-in-out";
      serviceSlides[currentSlideIndex].style.transition =
        "transform 0.5s ease-in-out";

      // Update the tab classes to reflect the active one
      serviceTabs[currentSlideIndex].classList.remove("active-tab");
      serviceTabs[index].classList.add("active-tab");

      // After the transition, hide the old slide
      setTimeout(() => {
        serviceSlides[currentSlideIndex].style.display = "none";
        currentSlideIndex = index;
      }, 500); // The timeout duration should match the transition duration
    }
  }

  // Ensure the first slide is visible on load
  serviceSlides[currentSlideIndex].style.transform = "translateY(0%)";
  serviceSlides[currentSlideIndex].style.display = "block";

  // Attach event listeners to the tabs
  serviceTabs.forEach((serviceTab, i) => {
    serviceTab.addEventListener("click", () => {
      showSlide(i);
    });
  });
}

//horizontal services slider
const hServiceTabs = Array.prototype.slice.call(
  document.querySelectorAll(".h-services-slides-tabs ul li")
);
const hServiceSlides = Array.prototype.slice.call(
  document.querySelectorAll(
    ".h-services-slides .kb-row-layout-wrap.kt-row-has-bg"
  )
);
if (hServiceTabs.length > 0 && hServiceSlides.length > 0) {
  let currentSlideIndexH = 0;

  function showSlideH(index) {
    if (index !== currentSlideIndexH) {
      // New slide enters from the right
      hServiceSlides[index].style.transform = "translateX(100%)";
      hServiceSlides[index].style.display = "block";

      // Force reflow to ensure the transition is applied
      hServiceSlides[index].offsetHeight;

      // Animate both slides simultaneously
      hServiceSlides[currentSlideIndexH].style.transform = "translateX(-100%)"; // Active slide exits through the left
      hServiceSlides[index].style.transform = "translateX(0%)"; // New slide enters from the right
      hServiceSlides[index].style.transition = "transform 0.5s ease-in-out";
      hServiceSlides[currentSlideIndexH].style.transition =
        "transform 0.5s ease-in-out";

      // Update the tab classes to reflect the active one
      hServiceTabs[currentSlideIndexH].classList.remove("active-tab");
      hServiceTabs[index].classList.add("active-tab");

      // After the transition, hide the old slide
      setTimeout(() => {
        hServiceSlides[currentSlideIndexH].style.display = "none";
        currentSlideIndexH = index;
      }, 500); // The timeout duration should match the transition duration
    }
  }

  // Ensure the first slide is visible on load
  hServiceSlides[currentSlideIndexH].style.transform = "translateX(0%)";
  hServiceSlides[currentSlideIndexH].style.display = "block";

  // Attach event listeners to the tabs
  hServiceTabs.forEach((hServiceTab, i) => {
    hServiceTab.addEventListener("click", () => {
      showSlideH(i);
    });
  });
}

// Blog lazy load fade in animation
document.addEventListener("DOMContentLoaded", function () {
  const lazyDivs = document.querySelectorAll(".lazy-div");

  const lazyLoad = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible"); // Add 'visible' class to trigger fade-in
        observer.unobserve(entry.target); // Stop observing once visible
      }
    });
  };

  const observer = new IntersectionObserver(lazyLoad, {
    rootMargin: "0px 0px -12% 0px",
    threshold: 0.1,
  });

  lazyDivs.forEach((div) => observer.observe(div));
});
